import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterTefl } from '../../../lib/types/models/center-tefl/center-tefl'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterTefls(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.centers.getCenterTefls.url, { id }), query))
    .get<PaginationResponse<CenterTefl>>()
}
